// extracted by mini-css-extract-plugin
export default {"form":"Pagination_form__p3r8o","btn":"Pagination_btn__Pd-Tj","active":"Pagination_active__eGaeg"};